<script>
    import { onMount, onDestroy } from "svelte";
    import Checkbox from "../../../Components/Custom/Table/Components/EncounterTable/Checkbox.svelte"

    import {
        decodeSearchParams,
        encodeSearchParams,
        getAmountInCurrency,
        getFormatDate,
        getText,
        goToURL,
        replaceURL,
        showError,
        showException,
        syncDefaultDoctorFilter,
    } from "../../../Utils/utilFunctions.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        SearchSelect,
        SvelteTable,
        PageLoading,
        NotificationModal,
        SearchInput,
        ResetFilterLink,
        DoctorMultiSearchSelect,
        DefaultDoctorFilter,
        Button,
        Loader,
    } from "../../../Components/Common/index.svelte";

    import TableFooter from "../../../Components/Layout/Table/TableFooter.svelte";

    import ReconcileEftCheckbox from "./ReconcileEftCheckbox.svelte";
    import { isEnvApp } from "../../../Utils/utilRoute.svelte";

    export let params = {};
    export let toggleShowEFTsTable = () => {};

    let isLoadingReconciliationEFTs = false,
        returnedReconciliationEFTs = [],
        filters = { reconciled: Number(0) },
        selectedReconciliationEftID = Number(0);

    let isReconcileEmptyReceiptsModalOpen = false,
        isReconciling = false,
        freeText;

    let isUndoReconcileModalOpen = false,
        isSendingUndoReconcileRequest = false,
        isShowUndoReconcileSuccessModal = false;

    let page = 0,
        pageSize = 25,
        count = 0;

    let hasMultipleGroups = false,
        hideAccountColumn = false; // hide column and doctor filter

    let selectedDoctors = [];

    let selectedEftsIdArr = [],
        checkEftsString = "",
        selectedEFts = [];

    let reconcileAllModalOpen = false,
        finishedItemNo = 0,
        failedIdArr = [],
        reconcileAllFinish = false;

    const batchApiCallNumber = 5;

    $: columns = [
        {
            key: "checkbox",
            title: "",
            headerClass:
                "toggleSelectAllHeader text-left px-3 w-[50px] cursor-default ml-3 rounded-tl-xl",
            class: (v) =>
                "text-left px-3 w-[50px] cursor-default cursor-default" +
                _getRowBgColor(v.checked),
            renderComponent: {
                component: ReconcileEftCheckbox,
                props: {
                    onToggleSelect: (row) => _updateSelectEftsArr(row),
                },
            },
            csvExportHidden: true,
        },
        {
            key: "id",
            title: "IDs",
            headerClass: "text-left px-3 w-[5%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[5%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getText(v.id),
        },
        {
            key: "groupName",
            title: "Group",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            isHidden: !hasMultipleGroups,
            renderValue: (v) => getText(v.groupName),
        },
        {
            key: "accountName",
            title: "Account",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            isHidden: hideAccountColumn,
            renderValue: (v) => getText(v.accountName),
        },
        {
            key: "transactionDate",
            title: "Date Received",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getFormatDate(v.transactionDate),
        },
        {
            key: "amount",
            title: "Amount",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getAmountInCurrency(v.amount),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left px-3 w-[20%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[20%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getText(v.transactionId),
        },
        {
            key: "reconciledDate",
            title: "Reconciled Date",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getFormatDate(v.reconciledDate),
        },
        {
            key: "reconciledBy",
            title: "Reconciled By",
            headerClass: "text-left px-3 w-[30%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[30%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => _renderUsers(v.userDetail),
        },
        {
            key: "description",
            title: "Description",
            headerClass: "text-left px-3 w-[30%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[30%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getText(v.description),
        },
        // {
        //     key: "paymentId",
        //     title: "Payment ID",
        //     headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
        //     class: "text-left px-3 w-[10%] cursor-default",
        //     renderValue: (v) =>
        //         v.paymentIds?.length ? getText(v.paymentIds.join(", ")) : "",
        // },
        {
            key: "receiptId",
            title: "Receipt ID",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) =>
                _renderReceiptIds(v.paymentIds, v.paymentsDetails),
            csvContent: (v) =>
                _renderReceiptIds(v.paymentIds, v.paymentsDetails, true),
        },
        {
            key: "paymentId",
            title: "Payment ID",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => _renderPaymentIds(v.paymentIds),
            csvContent: (v) => _renderPaymentIds(v.paymentIds, true),
        },
        {
            key: "invoiceId",
            title: "Invoice ID",
            headerClass: "text-left px-3 w-[10%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[10%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) =>
                _renderInvoiceIds(v.paymentIds, v.paymentsDetails),
            csvContent: (v) =>
                _renderInvoiceIds(v.paymentIds, v.paymentsDetails, true),
        },
        {
            key: "notes",
            title: "Notes",
            headerClass: "text-left px-3 w-[13%] cursor-default ml-3",
            class: (v) =>
                "text-left px-3 w-[13%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => getText(v.notes),
        },
        {
            key: "actions",
            title: "",
            headerClass: "text-right px-3 w-[5%] cursor-default rounded-tr-xl",
            class: (v) =>
                "text-right px-3 w-[5%] cursor-default" +
                _getRowBgColor(v.checked),
            renderValue: (v) => _renderActionIcons(v.reconciled),
            csvExportHidden: true,
        },
    ];

    onMount(async () => {
        if (params.query) updateSearchParamsByQuery(params.query);

        filters = await syncDefaultDoctorFilter(filters, "doctorId");

        loadReconciliationEFTs(page * pageSize, pageSize, _getSearchParams());
    });

    onDestroy(() => {
        selectedReconciliationEftID = Number(0);
    });

    var allEftsSelected = false;

    let selectAllCheckboxComponent = null;

    $: if (selectAllCheckboxComponent) {
        selectAllCheckboxComponent.$set({ checked: allEftsSelected });
    }

    const generateSelectAll = () => {
        const selectAllHeader = document.getElementsByClassName(
            "toggleSelectAllHeader",
        )[0];
        if(selectAllHeader){
            selectAllCheckboxComponent = new ReconcileEftCheckbox({
                target: selectAllHeader,
                props: {
                    checked: allEftsSelected,
                    onToggleSelect: (row) => toggleSelectAllEfts()
                }
            });
        }

        //set as all selected
        if(returnedReconciliationEFTs.every((eft) => eft.checked)) {
            allEftsSelected = true;
        }
    };


    const _updateSelectEftsArr = (row) => {
        row.checked = !row.checked;

        if (selectedEftsIdArr.includes(row.id)) {
            //check if exists as selected and remove it
            selectedEftsIdArr = selectedEftsIdArr.filter((id) => id != row.id);
            selectedEFts = selectedEFts.filter((eft) => eft.id != row.id);
        } else {
            //add new one
            selectedEftsIdArr = [...selectedEftsIdArr, row.id];
            selectedEFts = [...selectedEFts, row];
        }

        returnedReconciliationEFTs = returnedReconciliationEFTs.map((eft) => {
            if (eft.id == row.id) eft.checked = row.checked;
            return eft;
        });

        checkEftsString = _getCheckboxString(selectedEftsIdArr);

        if(returnedReconciliationEFTs.some((eft) => !eft.checked)) {
            allEftsSelected = false;
        }

        updateURL();
    };

    const toggleSelectAllEfts = () => {
        const anyUnselected = returnedReconciliationEFTs.some((eft) => !eft.checked);

        if (anyUnselected) {
            // Select all
            returnedReconciliationEFTs = returnedReconciliationEFTs.map((eft) => ({
                ...eft,
                checked: true
            }));

            selectedEftsIdArr = returnedReconciliationEFTs.map((eft) => eft.id);
            selectedEFts = [...returnedReconciliationEFTs];

            allEftsSelected = true;
        } else {
            // Deselect all
            returnedReconciliationEFTs = returnedReconciliationEFTs.map((eft) => ({
                ...eft,
                checked: false
            }));

            selectedEftsIdArr = [];
            selectedEFts = [];

            allEftsSelected = false;
        }

        checkEftsString = _getCheckboxString(selectedEftsIdArr);
        updateURL();
    };

    const updateSearchParamsByQuery = (query) => {
        const arr = decodeSearchParams(query).split("&");

        if (arr.length) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].includes("page="))
                    page = Number(arr[i].split("=")[1]);

                if (arr[i].includes("size="))
                    pageSize = Number(arr[i].split("=")[1]);

                if (arr[i].includes("search="))
                    filters.search = arr[i].split("=")[1];

                if (arr[i].includes("doctorId=")) {
                    if (isNaN(arr[i].split("=")[1])) {
                        filters.doctorId = arr[i].split("=")[1];
                        selectedDoctors = filters.doctorId
                            .split(",")
                            .map((id) => Number(id));
                    } else {
                        filters.doctorId = Number(arr[i].split("=")[1]);
                        selectedDoctors = [Number(filters.doctorId)];
                    }
                }

                if (arr[i].includes("amountFrom="))
                    filters.amountFrom = Number(arr[i].split("=")[1]);

                if (arr[i].includes("amountTo="))
                    filters.amountTo = Number(arr[i].split("=")[1]);

                if (arr[i].includes("reconciled="))
                    filters.reconciled = Number(arr[i].split("=")[1]);

                if (arr[i].includes("checkEfts=")) {
                    checkEftsString = arr[i].split("=")[1];
                    selectedEftsIdArr = checkEftsString
                        .split(",")
                        .map((id) => Number(id));
                }
            }
        }

        updateURL();
    };

    const loadReconciliationEFTs = async (start, limit, params) => {
        isLoadingReconciliationEFTs = true;

        await apiMethods.getMethod
            .getReconciliationEFT(start, limit, params)
            .then((res) => _handleReconciliationEFTs(res))
            .catch((err) =>
                showException(
                    "Failed to load data, please refresh the page and try again and contact support if the issue persists.",
                ),
            );

        isLoadingReconciliationEFTs = false;
    };

    const confirmReconciliationEmptyReceipts = async () => {
        isReconciling = true;

        await apiMethods.putMethod
            .updateReconciliationEFT({
                id: selectedReconciliationEftID,
                paymentIds: [],
                notes: freeText,
            })
            .then((res) => {
                if (res.error) showError(res.error);
                else {
                    freeText = "";
                    selectedReconciliationEftID = Number(0);

                    loadReconciliationEFTs(
                        page * pageSize,
                        pageSize,
                        _getSearchParams(),
                    );
                }
            })
            .catch((err) => showException(err));

        _closeReconcileEmptyReceiptsModal();

        isReconciling = false;
    };

    const reconcileAllSelectedEfts = async () => {
        isReconciling = true;

        finishedItemNo = 0;

        while (finishedItemNo < selectedEftsIdArr.length) {
            let numberOfThisBatch = 0;
            let promises = [];

            while (numberOfThisBatch < batchApiCallNumber) {
                let currentEftId =
                    selectedEftsIdArr[finishedItemNo + numberOfThisBatch];

                if (!currentEftId) {
                    numberOfThisBatch++;
                    continue;
                }

                promises.push(
                    apiMethods.putMethod
                        .updateReconciliationEFT({
                            id: currentEftId,
                            paymentIds: [],
                            notes: freeText,
                        })
                        .then((res) => {
                            if (!res || res.error) {
                                showError(
                                    res.error ??
                                        `Failed to reconcile selected EFT, id ${currentEftId}, please refresh the page and try again and contact support if the issue persists.`,
                                );
                                failedIdArr.push(currentEftId);
                            }
                        })
                        .catch((err) => failedIdArr.push(currentEftId)),
                );
                numberOfThisBatch++;
            }

            await Promise.all(promises);

            finishedItemNo += promises.length;
        }

        isReconciling = false;
        reconcileAllFinish = true;
    };

    const undoEFT = async () => {
        isSendingUndoReconcileRequest = true;

        await apiMethods.putMethod
            .sendUndoEraOrEftRequest("eft", selectedReconciliationEftID)
            .then((res) => _handleUndoReconcileRequest(res))
            .catch((err) => showException(err));

        _closeUndoReconcileModal();

        isSendingUndoReconcileRequest = false;
    };

    const handleFilterSelect = () => {
        page = 0;

        updateURL();

        loadReconciliationEFTs(0, pageSize, _getSearchParams());
    };

    const handleSelectDoctor = () => {
        filters.doctorId = selectedDoctors.join(",");

        handleFilterSelect();
    };

    const clearFilterDoctor = () => {
        selectedDoctors = [];

        delete filters.doctorId;

        handleFilterSelect();
    };

    const updateURL = () => {
        if (!checkEftsString)
            replaceURL(
                `/Reconciliations/tab=EFTs&page=${page}&size=${pageSize}${_getParamsString()}`,
            );
        else
            replaceURL(
                `/Reconciliations/tab=EFTs&page=${page}&size=${pageSize}${_getParamsString()}&checkEfts=${checkEftsString}`,
            );
    };

    const onPageChange = (e) => {
        page = Number(e.detail.page);

        updateURL();

        loadReconciliationEFTs(page * pageSize, pageSize, _getSearchParams());
    };

    const onPageSizeChange = (newPageSize) => {
        pageSize = newPageSize;
        page = 0;

        updateURL();

        loadReconciliationEFTs(0, pageSize, _getSearchParams());
    };

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        if (key == "actions") {
            selectedReconciliationEftID = Number(rowData.id);
            if (className.includes("reconciledIcon"))
                toggleShowEFTsTable(selectedReconciliationEftID);
            else if (className.includes("reconcileWithoutMatchingIcon"))
                _openReconcileEmptyReceiptsModal();
            else if (className.includes("undoIcon")) _openUndoReconcileModal();
        } else if (className.includes("clickable")) {
            const invoicePattern = /invoice-(\d+)/;

            const matchInvoice = className.match(invoicePattern);

            matchInvoice && goToURL(`/Invoices/view/${matchInvoice[1]}`);
        }
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    // HELPER FUNCTIONS
    const _handleReconciliationEFTs = async (res, isCsvContent = false) => {
        if (res.error) showError(res.error);
        else if (res.results && res.results.length) {
            let results = [];

            if (!isCsvContent) {
                returnedReconciliationEFTs = [...res.results];

                returnedReconciliationEFTs.map((eft) => {
                    if (!selectedEftsIdArr.length) eft.checked = false;
                    else eft.checked = selectedEftsIdArr.includes(eft.id);

                    if (selectedEftsIdArr.includes(eft.id))
                        selectedEFts = [...selectedEFts, eft];
                });

                count = res.total;
            }

            results = await _mapUserName(res.results);

            _determineGroupAndAccountColumnVisibility(results);

            if (isCsvContent) return results;
            else returnedReconciliationEFTs = [...results];
        } else if (!res.results.length) {
            returnedReconciliationEFTs = [];
            count = Number(0);

            return [];
        }

         setTimeout(() => {
            generateSelectAll();
            //_updateCheckBox();
        }, 1);
    };

    const _determineGroupAndAccountColumnVisibility = (results) => {
        if (!results || !results.length || results.length == 1) {
            hasMultipleGroups = false;
            hideAccountColumn = results[0].accountId == 0;
            return;
        }

        const { groupId } = results[0];

        hasMultipleGroups = results.some((res) => res.groupId != groupId);
        hideAccountColumn = !results.some((res) => res.accountId != 0);
    };

    const _handleUndoReconcileRequest = (res) => {
        if (!res || !res.id || res.error)
            showError(
                "Failed to undo selected EFT, please refresh the page and try again and contact support if the issue persists.",
            );
        else {
            _openUndoReconcileSuccessModal();
            loadReconciliationEFTs(
                page * pageSize,
                pageSize,
                _getSearchParams(),
            );
        }
    };

    const _mapUserName = async (arr) => {
        if (!arr.length) return;

        const userIdArr = [];
        const promises = [];

        arr.forEach((reconciliation) => {
            if (
                reconciliation.reconciledBy &&
                !userIdArr.includes(reconciliation.reconciledBy)
            ) {
                userIdArr.push(reconciliation.reconciledBy);

                promises.push(
                    apiMethods.getMethod
                        .getUserById(Math.abs(reconciliation.reconciledBy))
                        .then((res) => {
                            if (res.id) {
                                arr.map((reconciliationDataForAcc) => {
                                    if (
                                        reconciliationDataForAcc.reconciledBy ==
                                        res.id
                                    )
                                        reconciliationDataForAcc.userDetail = {
                                            name: res.fullName || "",
                                            email: res.email || "",
                                        };
                                });
                            }
                        }),
                );
            }
        });

        await Promise.all(promises);

        return arr;
    };

    const _getSearchParams = () => {
        let params = {};

        if (filters.search) params.search = filters.search;

        if (filters.doctorId) params["filter[doctorId]"] = filters.doctorId;

        let { amountFrom, amountTo } = filters;

        // If both exist and are in the wrong order, swap them
        if (amountFrom && amountTo && amountFrom > amountTo) {
            [amountFrom, amountTo] = [amountTo, amountFrom];
        }

        // Assign to params if they exist
        if (amountFrom) params["filter[amountFrom]"] = amountFrom;
        if (amountTo) params["filter[amountTo]"] = amountTo;

        if (filters.reconciled || filters.reconciled == Number(0))
            params["filter[reconciled]"] = Number(filters.reconciled);

        return params;
    };

    const _getParamsString = () => {
        let str = "";
        const params = _getSearchParams();

        if (params) {
            if (params.search) str += `&search=${params.search}`;

            if (params["filter[doctorId]"])
                str += `&doctorId=${params["filter[doctorId]"]}`;

            if (
                params["filter[amountFrom]"] ||
                params["filter[amountFrom]"] == Number(0)
            )
                str += `&amountFrom=${params["filter[amountFrom]"]}`;

            if (
                params["filter[amountTo]"] ||
                params["filter[amountTo]"] == Number(0)
            )
                str += `&amountTo=${params["filter[amountTo]"]}`;

            if (
                params["filter[reconciled]"] ||
                params["filter[reconciled]"] == Number(0)
            )
                str += `&reconciled=${params["filter[reconciled]"]}`;
        }

        return encodeSearchParams(str);
    };

    const _renderUsers = (userDetail) => {
        if (!userDetail) return "";

        if (!userDetail.name)
            if (!userDetail.email) return "";
            else return getText(userDetail.email);

        if (!userDetail.email) return getText(userDetail.name);

        return `${getText(userDetail.name)} (${getText(userDetail.email)})`;
    };

    const _renderReceiptIds = (
        idsArr = [],
        detailsArr = [],
        isCsvContent = false,
    ) => {
        if (!idsArr.length && !detailsArr.length) return "-";

        const res = [];

        idsArr.map((id) => {
            const paymentDetail = detailsArr.find(
                (item) => item.paymentId == id,
            );

            if (paymentDetail) res.push(paymentDetail.receiptNumber ?? "-");
        });

        return res.join(isCsvContent ? "\r\n" : "<br>").toString();
    };

    const _renderPaymentIds = (idsArr = [], isCsvContent = false) => {
        if (!idsArr || !idsArr.length) return "-";

        const res = [];

        idsArr.map((id) => {
            res.push(id);
        });

        return res.join(isCsvContent ? "\r\n" : "<br>").toString();
    };

    const _renderInvoiceIds = (
        idsArr = [],
        detailsArr = [],
        isCsvContent = false,
    ) => {
        if (!idsArr.length && !detailsArr.length) return "-";

        const res = [];

        idsArr.map((id) => {
            const paymentDetail = detailsArr.find(
                (item) => item.paymentId == id,
            );

            if (paymentDetail)
                res.push(
                    paymentDetail.relNumber && paymentDetail.relId
                        ? isCsvContent
                            ? `${paymentDetail.relNumber}`
                            : `<p class="underline cursor-pointer clickable invoice-${paymentDetail.relId}">${paymentDetail.relNumber}</p>`
                        : "-",
                );
        });

        return res.join(isCsvContent ? "\r\n" : "<br>").toString();
    };

    const _renderActionIcons = (reconciled) => {
        return reconciled
            ? `<div class="flex flex-1 items-center justify-center gap-x-2">
                    <div class="undoIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Undo Reconcile">
                        <i class="undoIcon fa-solid fa-rotate-left cursor-pointer"></i>
                    </div>
                </div>`
            : `<div class="flex flex-1 items-center justify-center gap-x-2">
                    <div class="reconciledIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Reconcile">
                        <i class="reconciledIcon fa-solid fa-list-check cursor-pointer"></i>
                    </div>

                    <div class="reconcileWithoutMatchingIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] cursor-pointer hover:rounded-full hover:bg-secondary hover:text-white" data-tip="Reconcile Without Matching Receipts">
                        <i class="reconcileWithoutMatchingIcon fa-solid fa-triangle-exclamation"></i>
                    </div>
                </div>`;
    };

    const _openReconcileEmptyReceiptsModal = () =>
        (isReconcileEmptyReceiptsModalOpen = true);

    const _closeReconcileEmptyReceiptsModal = () =>
        (isReconcileEmptyReceiptsModalOpen = false);

    const _openUndoReconcileModal = () => (isUndoReconcileModalOpen = true);

    const _closeUndoReconcileModal = () => {
        isUndoReconcileModalOpen = false;
        selectedReconciliationEftID = Number(0);
    };

    const _openUndoReconcileSuccessModal = () =>
        (isShowUndoReconcileSuccessModal = true);

    const _closeUndoReconcileSuccessModal = () =>
        (isShowUndoReconcileSuccessModal = false);

    const _getRowBgColor = (isChecked = false) =>
        isChecked ? " bg-slate-200" : "";

    const _getCheckboxString = (idArr) => {
        if (!idArr.length) return "";

        return idArr.join();
    };

    const _openReconcileAllModal = () => (reconcileAllModalOpen = true);

    const _closeReconcileAllModal = (clearSelectedEfts = false) => {
        reconcileAllModalOpen = false;
        finishedItemNo = 0;
        failedIdArr = [];
        reconcileAllFinish = false;
        freeText = "";

        if (clearSelectedEfts) {
            checkEftsString = "";
            selectedEftsIdArr = [];
            selectedEFts = [];
            updateURL();
            loadReconciliationEFTs(
                page * pageSize,
                pageSize,
                _getSearchParams(),
            );
        }
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    <div class="flex flex-col gap-y-4 flex-0">
        <div class="flex flex-row justify-between items-end">
            <div class="flex gap-4 flex-wrap items-end">
                <SearchInput
                    bind:value={filters.search}
                    title="Search"
                    inputFunc={handleFilterSelect}
                />

                {#if !hideAccountColumn}
                    <DefaultDoctorFilter
                        bind:filter={filters}
                        filterPropertyName="doctorId"
                        onChangeFunc={handleFilterSelect}
                    />

                    <DoctorMultiSearchSelect
                        bind:searchResult={selectedDoctors}
                        onChangeFunc={handleSelectDoctor}
                        inputClass="w-32"
                        zIndex="3"
                    />
                {/if}

                <SearchInput
                    bind:value={filters.amountFrom}
                    title="Amount From"
                    type="number"
                    inputFunc={() => {
                        if (!isNaN(filters.amountFrom)) handleFilterSelect();
                    }}
                />

                <SearchInput
                    bind:value={filters.amountTo}
                    title="Amount To"
                    type="number"
                    inputFunc={() => {
                        if (!isNaN(filters.amountTo)) handleFilterSelect();
                    }}
                />

                <SearchSelect
                    bind:value={filters.reconciled}
                    title="Reconciled"
                    onChangeFunc={handleFilterSelect}
                >
                    <option value={Number(1)}>Yes</option>
                    <option value={Number(0)}>No</option>
                </SearchSelect>

                <ResetFilterLink
                    bind:filter={filters}
                    onResetFilter={() => {
                        clearFilterDoctor();
                    }}
                />
            </div>

            {#if selectedEftsIdArr.length}
                <Button clickFunc={_openReconcileAllModal}>
                    Reconcile All
                </Button>
            {/if}
        </div>
    </div>

    {#if isLoadingReconciliationEFTs}
        <PageLoading />
    {:else if returnedReconciliationEFTs.length}
        <div class="relative flex-1">
            <div class="overflow-y-auto absolute inset-0">
                <SvelteTable
                    columns={columns.filter((col) => !col.isHidden)}
                    rows={returnedReconciliationEFTs}
                    clickCellFunc={({ detail: { event, row, key } }) => {
                        handleClickCell(event, row, key);
                    }}
                    clickColFunc={({ detail: { event, row, key } }) => {
                        handleClickCol(event, row, key);
                    }}
                />
            </div>
        </div>

        <TableFooter
            {page}
            {pageSize}
            {count}
            tableData={returnedReconciliationEFTs}
            {onPageChange}
            {onPageSizeChange}
            csvConfig={{
                columns: columns.filter((col) => !col.isHidden),
                data: returnedReconciliationEFTs,
                fileName: "Reconciliation EFTs",
                allDataApi: async () => {
                    let res = await apiMethods.getMethod.getReconciliationEFT(
                        0,
                        999999,
                        _getSearchParams(),
                    );

                    const results = await _handleReconciliationEFTs(res, true);

                    return { results };
                },
            }}
        />
    {:else}
        <div class="flex flex-1 items-center justify-center text-2xl font-bold">
            No EFTs
        </div>
    {/if}
</div>

<NotificationModal
    isModalOpen={isReconcileEmptyReceiptsModalOpen}
    isConfirming={isReconciling}
    closeModal={_closeReconcileEmptyReceiptsModal}
    title="Reconcile this EFT without matching it to a receipt?"
    cancelText="Cancel"
    closeModalFunction={_closeReconcileEmptyReceiptsModal}
    showConfirmBtn={false}
    btnOptions={[
        {
            text: isReconciling ? "Confirming" : "Reconcile",
            loading: isReconciling || (isEnvApp() && !freeText),
            function: () => confirmReconciliationEmptyReceipts(),
        },
    ]}
>
    <textarea
        cols="30"
        rows="5"
        class="textarea w-full textarea-bordered"
        bind:value={freeText}
        placeholder="Notes"
        autocomplete="off"
    />
</NotificationModal>

<NotificationModal
    isModalOpen={isUndoReconcileModalOpen}
    title="Undo reconciliation?"
    cancelText="Cancel"
    submitText="Confirm"
    closeModal={_closeUndoReconcileModal}
    confirmAction={undoEFT}
    isConfirming={isSendingUndoReconcileRequest}
    closeModalFunction={_closeUndoReconcileModal}
>
    <p class="leading-6">
        This will mark the EFT and associated ERAs as <i>NOT reconciled</i>,
        change the status of ALL associated payments to <i>Pending</i> and
        change the billing status of associated encounters to
        <i>In Progress</i>.
    </p>
    <p class="leading-6">Continue?</p>
</NotificationModal>

<NotificationModal
    isModalOpen={isShowUndoReconcileSuccessModal}
    closeModal={_closeUndoReconcileSuccessModal}
    showConfirmBtn={false}
    isColouredTitle={false}
    closeModalFunction={_closeUndoReconcileSuccessModal}
>
    Successfully undo selected reconciliation
</NotificationModal>

<NotificationModal
    isModalOpen={reconcileAllModalOpen}
    title="Reconcile Selected EFTs"
    closeModal={() => _closeReconcileAllModal(reconcileAllFinish)}
    closeModalFunction={() => _closeReconcileAllModal(reconcileAllFinish)}
    cancelText={reconcileAllFinish ? "Close" : "Cancel"}
    isConfirming={isReconciling}
    showConfirmBtn={false}
    btnOptions={[
        {
            text: "Reconcile",
            isHidden: reconcileAllFinish,
            loading: isReconciling || (isEnvApp() && !freeText),
            function: () => reconcileAllSelectedEfts(),
        },
    ]}
>
    <div class="flex flex-col gap-y-2 p-4">
        {#if isReconciling || reconcileAllFinish}
            <div class="flex gap-x-2 items-center">
                {#if !reconcileAllFinish}
                    <Loader />
                {/if}
                <p class="leading-6 font-semibold">
                    {finishedItemNo - failedIdArr.length} / {selectedEftsIdArr.length}
                    Finished
                </p>
            </div>

            {#if reconcileAllFinish && failedIdArr.length}
                <p class="text-error leading-6 font-bold">
                    {failedIdArr.length} Failed
                </p>
            {/if}
        {:else}
            <p>
                Reconcile all the selected EFTs without matching them to a
                receipt?
            </p>

            <textarea
                cols="30"
                rows="5"
                class="textarea w-full textarea-bordered"
                bind:value={freeText}
                placeholder="Notes"
                autocomplete="off"
            />
        {/if}
    </div>
</NotificationModal>
